// extracted by mini-css-extract-plugin
export default {"cta":"EH-z","disabled":"FH-z"};